export default __webpack_public_path__ + "static/media/Eps.ac672c77.svg";